var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FieldType, } from "@brushfire/types";
import { remoteFetch, remoteValidate } from "./api";
import Constants from "./constants";
import * as Yup from "yup";
import { setPageError } from "../store/AppState/actions";
import { phone } from "phone";
import { getLocal, LOCAL_STORAGE_KEYS, removeLocal } from "./localStorageHelpers";
import { v4 as uuidv4 } from "uuid";
import { INTEGRATIONS_LOCAL_STORAGE_KEYS } from "../store/Integrations/types";
export var convertToFieldViews = function (fields) {
    var ret = [];
    fields.forEach(function (field) {
        if (field.specialFieldId && field.specialFieldId !== field.id) {
            if (ret.find(function (a) { return a.specialFieldId === field.specialFieldId; }) === undefined) {
                var newField = {
                    id: field.specialFieldId,
                    label: field.label.replace(" (Country)", ""),
                    type: field.type,
                    value: "",
                    validationExpression: "",
                    isRequired: field.isRequired,
                    notes: field.notes,
                    hasError: field.hasError,
                    errorMessage: field.errorMessage,
                    isDisabled: field.isDisabled,
                    isSensitive: field.isSensitive,
                    isIntegration: false,
                    isAdmin: false,
                    specialFieldId: field.specialFieldId,
                    specialFieldLabel: field.specialFieldLabel,
                    parentOptionId: field.parentOptionId,
                    parentFieldId: field.parentFieldId,
                    formObjectId: field.formObjectId,
                    options: field.options,
                    confirm: field.confirm,
                    childFields: fields
                        .filter(function (f) { return f.specialFieldId === field.specialFieldId; })
                        .map(function (f, index) {
                        var _a;
                        var childField = __assign(__assign({}, f), { id: f.id, childFields: [], isIntegration: false, isAdmin: false, displayOrder: index, specialFieldLabel: f.specialFieldLabel });
                        if (f.label.includes("Country")) {
                            childField.value = (_a = childField.value) !== null && _a !== void 0 ? _a : "US";
                        }
                        return childField;
                    }),
                    remoteUrl: field.remoteUrl,
                    parentOptionIsSelected: field.parentOptionIsSelected,
                    hasRelevantOutput: field.hasRelevantOutput,
                };
                ret.push(newField);
            }
        }
        else {
            ret.push(__assign(__assign({}, field), { childFields: [], isIntegration: false, isAdmin: false }));
        }
    });
    return ret;
};
export var getInitialFieldValues = function (ret, fields, event) {
    fields.forEach(function (field) {
        var _a;
        if (field.childFields.length === 0) {
            if (Constants.FieldsWithOptions.includes(field.type)) {
                var val_1 = [];
                if (Array.isArray(field.value)) {
                    var values_1 = field.value;
                    field.options.forEach(function (opt, index) {
                        var found = values_1.find(function (v) { return v.id === opt.id; });
                        if (field.type === FieldType[FieldType.Radiobuttons] ||
                            field.type === FieldType[FieldType.Dropdown]) {
                            if (!!found) {
                                val_1.push(found);
                            }
                        }
                        else {
                            val_1[index] = found ? found : null;
                        }
                    });
                }
                ret[field.id] = val_1;
            }
            else if (field.type === FieldType[FieldType.Phone]) {
                if (field.confirm) {
                    var res = phone((_a = field.value) === null || _a === void 0 ? void 0 : _a.value, {
                        validateMobilePrefix: false,
                    });
                    if (res.isValid && res.phoneNumber !== field.value) {
                        ret[field.id] = {
                            value: res.phoneNumber,
                            confirmValue: res.phoneNumber,
                        };
                    }
                    else {
                        ret[field.id] = {
                            value: field.value.value,
                            confirmValue: field.value.confirmValue,
                        };
                    }
                }
                else {
                    var res = phone(field.value, { validateMobilePrefix: false });
                    if (res.isValid && res.phoneNumber !== field.value) {
                        ret[field.id] = res.phoneNumber;
                    }
                    else {
                        ret[field.id] = field.value;
                    }
                }
            }
            else {
                if (field.confirm) {
                    ret[field.id] = {
                        value: field.value.value,
                        confirmValue: field.value.confirmValue,
                    };
                }
                else {
                    var referralRockCode = getLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_CODE);
                    var referralRockField = getLocal(INTEGRATIONS_LOCAL_STORAGE_KEYS.REFERRAL_ROCK_FIELD);
                    if (referralRockCode &&
                        referralRockField &&
                        field.label.toLowerCase() === referralRockField.toLowerCase()) {
                        ret[field.id] = referralRockCode;
                    }
                    else {
                        ret[field.id] = field.value;
                    }
                    if (field.type === "Signature" && Array.isArray(ret[field.id].roles)) {
                        ret[field.id].roles.forEach(function (role) {
                            return role.hasOwnProperty("userId") ? (role.userId = uuidv4()) : null;
                        });
                    }
                }
            }
        }
        else {
            field.childFields.forEach(function (child) {
                var _a;
                if (child.specialFieldLabel.toLowerCase() === "country") {
                    ret[child.id] = child.value !== "" ? child.value : (_a = event.clientCountry) !== null && _a !== void 0 ? _a : "US";
                }
                else if (field.confirm) {
                    ret[child.id] = {
                        value: child.value.value,
                        confirmValue: child.value.confirmValue,
                    };
                }
                else {
                    ret[child.id] = child.value;
                }
            });
        }
    });
    // Get list of saved query values
    var queryValuesString = getLocal(LOCAL_STORAGE_KEYS.QUERY_VALUES);
    var queryValues = JSON.parse(queryValuesString !== null && queryValuesString !== void 0 ? queryValuesString : "{}");
    Object.keys(ret).forEach(function (k) {
        var _a, _b, _c;
        var val = ret[k];
        //Check if the default value is using handlebars
        if (typeof val === "string" && val.startsWith("{{") && val.endsWith("}}")) {
            var key = val.replace("{{", "").replace("}}", "");
            ret[k] = (_a = queryValues[key]) !== null && _a !== void 0 ? _a : "";
        }
        else if ((val === null || val === void 0 ? void 0 : val.value) && val.value.startsWith("{{") && val.value.endsWith("}}")) {
            var key = val.value.replace("{{", "").replace("}}", "");
            ret[k] = {
                value: (_b = queryValues["".concat(key, "-value")]) !== null && _b !== void 0 ? _b : "",
                label: (_c = queryValues["".concat(key, "-label")]) !== null && _c !== void 0 ? _c : "",
            };
        }
    });
    return ret;
};
export var handleErrors = function (error, dispatch, formikHelpers, setGlobalError, usePageRedirect, skipGlobalError) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    if (usePageRedirect === void 0) { usePageRedirect = false; }
    var formikErrors = {};
    if (usePageRedirect) {
        dispatch(setPageError({
            status: (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : 500,
            error: (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data.message) !== null && _d !== void 0 ? _d : "An error occured. Please refresh or try again later.",
            stackTrace: (_e = error.response) === null || _e === void 0 ? void 0 : _e.data.stackTrace,
        }));
    }
    else if ((_g = (_f = error.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.stackTrace) {
        log("API Error ".concat(error.response.data.stackTrace), Style.error);
    }
    if ((_j = (_h = error.response) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.hasOwnProperty("errors")) {
        var data = (_k = error.response) === null || _k === void 0 ? void 0 : _k.data;
        var errors = (_m = (_l = data.errors) === null || _l === void 0 ? void 0 : _l.map(function (err) { return ({
            key: err.key.replace("fields[", "").replace("].value", ""),
            value: err.value,
        }); })) !== null && _m !== void 0 ? _m : [];
        if (formikHelpers) {
            errors.forEach(function (err) {
                var _a, _b;
                if (((_a = formikHelpers.values[err.key]) === null || _a === void 0 ? void 0 : _a.hasOwnProperty("value")) &&
                    ((_b = formikHelpers.values[err.key]) === null || _b === void 0 ? void 0 : _b.hasOwnProperty("confirmValue"))) {
                    formikErrors[err.key] = {
                        confirmValue: err.value,
                        value: err.value,
                    };
                }
                else {
                    formikErrors[err.key] = err.value;
                }
            });
            formikHelpers.setErrors(formikErrors);
            setTimeout(function () {
                var errorInputs = document.getElementsByClassName("error-input");
                if (!!errorInputs.length) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    errorInputs[0].focus();
                }
            });
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
    }
    else if (((_p = (_o = error.response) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.message) && !((_r = (_q = error.response) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.errors) && setGlobalError && !skipGlobalError) {
        setGlobalError(error.response.data.message);
    }
};
export var platformAwareRedirect = function (url, isWidget, history) {
    if (window.top !== window.self || isWidget) {
        history.push(url);
    }
    else {
        window.location.href = url;
    }
};
export var getPaymentMethodId = function (cardType) {
    return new Promise(function (resolve, reject) {
        if (cardType.toLowerCase() === "visa") {
            resolve(Constants.PaymentMethods.PAYMENTMETHOD_VISA);
        }
        else if (cardType.toLowerCase() === "discover") {
            resolve(Constants.PaymentMethods.PAYMENTMETHOD_DISCOVER);
        }
        else if (cardType.toLowerCase() === "amex" ||
            cardType.toLowerCase() === "americanexpress" ||
            cardType.toLowerCase() === "american_express") {
            resolve(Constants.PaymentMethods.PAYMENTMETHOD_AMERICANEXPRESS);
        }
        else if (cardType.toLowerCase() === "mastercard") {
            resolve(Constants.PaymentMethods.PAYMENTMETHOD_MASTERCARD);
        }
        else if (cardType.toLowerCase() === "square") {
            resolve(Constants.PaymentMethods.PAYMENTMETHOD_SQUARE);
        }
        else {
            reject("Unsupported Payment Method");
        }
    });
};
export var isVisible = function (field, schemaParent, fieldViews) {
    if (!!field.parentFieldId) {
        //Check if the parent has a parent
        var parentField = fieldViews.find(function (f) { return f.id === field.parentFieldId; });
        var parentValue = schemaParent[field.parentFieldId];
        if (parentField &&
            (parentValue === field.parentOptionId ||
                (Array.isArray(parentValue) &&
                    parentValue.some(function (x) { return (x === null || x === void 0 ? void 0 : x.id) === field.parentOptionId; })))) {
            var ret = isVisible(parentField, schemaParent, fieldViews);
            return ret;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
};
export var testRequiredness = function (value, field, schemaParent, fieldViews, childFieldType) {
    if (isVisible(field, schemaParent, fieldViews)) {
        if (Constants.FieldsWithOptions.includes(field.type)) {
            //Option values are an array. If there is nothing in the array, no selection was made
            //Confirm if an option value was selected
            if (Array.isArray(value) && value.length > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        if (!!value || !field.isRequired || childFieldType === "Street 2") {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
};
export var getRemoteValidateRes = function (fieldId, value, setResponse, eventNumber, attendeeNumber) {
    if (fieldId && eventNumber) {
        remoteValidate(eventNumber, fieldId, value, attendeeNumber)
            .then(function (_a) {
            var data = _a.data;
            setResponse(data);
        })
            .catch(function (err) {
            setResponse(false);
            log(err, Style.error);
        });
    }
    else {
        setResponse(false);
    }
};
export var getRemoteFetchValues = function (fieldId, value, setRemoteData, eventNumber, attendeeNumber) {
    if (fieldId && eventNumber) {
        remoteFetch(eventNumber, fieldId, value, attendeeNumber)
            .then(function (_a) {
            var data = _a.data;
            setRemoteData(data);
        })
            .catch(function (err) {
            setRemoteData([]);
            log(err, Style.error);
        });
    }
    else {
        setRemoteData([]);
    }
};
export var handleSubmittedOrder = function (orderResult, event, history, postAttendeeOrder, finishUrl) {
    if (postAttendeeOrder === void 0) { postAttendeeOrder = false; }
    if (event.orderTracking && event.orderTracking !== "") {
        //{0} Order Quantity: {1} Order Number: {2} Event Number: {3} Event Title: {4} Order Email: {5}
        var parsedScripts = event.orderTracking
            .replaceAll("{{", "{")
            .replaceAll("}}", "}")
            .replaceAll("{0}", orderResult.total.toFixed(2))
            .replaceAll("{1}", orderResult.attendeeCount.toString())
            .replaceAll("{2}", orderResult.orderKey)
            .replaceAll("{3}", event.eventNumber.toString())
            .replaceAll("{4}", event.titleInfo)
            .replaceAll("{5}", orderResult.email)
            .replaceAll("{6}", orderResult.firstName)
            .replaceAll("{7}", orderResult.lastName);
        var dom = new DOMParser().parseFromString(parsedScripts, "text/html");
        var scripts = dom.documentElement.querySelectorAll("script");
        scripts.forEach(function (el) {
            if (el === null || el === void 0 ? void 0 : el.src) {
                var script = document.createElement("script");
                if (el.hasAttributes()) {
                    for (var i = 0; i < el.attributes.length; i++) {
                        var attr = el.attributes[i];
                        script.setAttribute(attr.name, attr.value);
                    }
                }
                //TODO add these in once log helper method is added back
                // script.addEventListener("load", function() {
                // 	console.log("Loaded external script");
                // });
                // script.addEventListener("error", function() {
                // 	console.log("Error loading external script");
                // });
                document.body.appendChild(script);
            }
            else {
                if (el.textContent) {
                    try {
                        eval(el.textContent);
                    }
                    catch (e) {
                        console.error("Error executing the following script:");
                        console.error(el.textContent);
                    }
                }
            }
        });
    }
    removeLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(event.eventNumber));
    removeLocal("".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(event.eventNumber));
    removeLocal(LOCAL_STORAGE_KEYS.PROMO);
    removeLocal(LOCAL_STORAGE_KEYS.REMOVED_PROMOS);
    if (postAttendeeOrder === false) {
        removeLocal("".concat(LOCAL_STORAGE_KEYS.CART_ID, "-").concat(event.eventNumber));
    }
    var url = Constants.Routes.results
        .replace(":clientKey", event.clientKey)
        .replace(":urlKey", event.urlKey)
        .replace(":eventNumber", event.eventNumber.toString())
        .replace(":hash", orderResult.orderHash);
    history.replace(url, { orderResult: orderResult, postAttendeeOrder: postAttendeeOrder, finishUrl: finishUrl });
};
export var getDynamicFieldValidation = function (fieldViews) {
    var fieldShape = {};
    fieldViews.forEach(function (field) {
        var _a, _b, _c, _d, _e, _f;
        var caseInsensitiveCompare = function (a, b) { return (a === null || a === void 0 ? void 0 : a.toLowerCase()) === (b === null || b === void 0 ? void 0 : b.toLowerCase()); };
        if (Constants.FieldsWithOptions.includes(field.type)) {
            fieldShape[field.id] = Yup.array().nullable();
        }
        else if (field.type === FieldType[FieldType.RemoteFetch]) {
            // This should be nullable if it has a parent field id, and the parent field is not visible
            var remoteFetchFieldShape = Yup.object().shape({
                label: Yup.string(),
                value: Yup.string(),
            });
            if (field.parentFieldId && field.parentOptionIsSelected && field.isRequired) {
                fieldShape[field.id] = remoteFetchFieldShape.required();
            }
            else {
                fieldShape[field.id] = remoteFetchFieldShape.nullable();
            }
        }
        else {
            fieldShape[field.id] = Yup.string().nullable();
        }
        if (field.confirm) {
            if (field.childFields.length === 0) {
                fieldShape[field.id] = Yup.object().shape({
                    value: fieldShape[field.id]
                        .test("".concat(field.id, "-regex-test"), "".concat(field.label, " is invalid"), function (value) {
                        if (isVisible(field, this.parent, fieldViews)) {
                            if (!!field.validationExpression) {
                                return ((!field.isRequired && !value) ||
                                    new RegExp(field.validationExpression).test(value));
                            }
                            else {
                                return true;
                            }
                        }
                        else {
                            return true;
                        }
                    })
                        .test("".concat(field.id, "-domain-test"), function (_a) {
                        var value = _a.value;
                        return "Emails from '".concat(value.split("@").pop(), "' are not allowed");
                    }, function (value) {
                        var _a, _b, _c, _d, _e;
                        if (!!field.domainValidation && field.type === FieldType[FieldType.Email]) {
                            if (((_b = (_a = field.domainValidation) === null || _a === void 0 ? void 0 : _a.disallowDomains) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                                if (((_c = field.domainValidation) === null || _c === void 0 ? void 0 : _c.disallowDomains) !== undefined &&
                                    ((_d = field.domainValidation) === null || _d === void 0 ? void 0 : _d.disallowDomains.length) > 0) {
                                    return !((_e = field.domainValidation) === null || _e === void 0 ? void 0 : _e.disallowDomains.some(function (d) {
                                        return value === null || value === void 0 ? void 0 : value.toLowerCase().endsWith("@" + d);
                                    }));
                                }
                            }
                        }
                        return true;
                    })
                        .test("".concat(field.id, "-domain-test"), "Only emails from the following domains are allowed: ".concat((_b = (_a = field === null || field === void 0 ? void 0 : field.domainValidation) === null || _a === void 0 ? void 0 : _a.allowDomains) === null || _b === void 0 ? void 0 : _b.join(", ")), function (value) {
                        var _a, _b, _c, _d, _e;
                        if (!!field.domainValidation && field.type === FieldType[FieldType.Email]) {
                            if (((_b = (_a = field.domainValidation) === null || _a === void 0 ? void 0 : _a.allowDomains) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                                if (((_c = field.domainValidation) === null || _c === void 0 ? void 0 : _c.allowDomains) !== undefined &&
                                    ((_d = field.domainValidation) === null || _d === void 0 ? void 0 : _d.allowDomains.length) > 0) {
                                    return (_e = field.domainValidation) === null || _e === void 0 ? void 0 : _e.allowDomains.some(function (d) {
                                        return value === null || value === void 0 ? void 0 : value.toLowerCase().endsWith("@" + d);
                                    });
                                }
                            }
                        }
                        return true;
                    }),
                    confirmValue: fieldShape[field.id]
                        .test("".concat(field.id, "-regex-test"), "".concat(field.label, " is invalid"), function (value) {
                        if (isVisible(field, this.parent, fieldViews)) {
                            if (!!field.validationExpression) {
                                return ((!field.isRequired && !value) ||
                                    new RegExp(field.validationExpression).test(value));
                            }
                            else {
                                return true;
                            }
                        }
                        else {
                            return true;
                        }
                    })
                        .test("".concat(field.id, "-confirm-value-test"), "Confirmation value must match", function (value) {
                        if (isVisible(field, this.parent, fieldViews)) {
                            var originalValue = this.parent.value;
                            return caseInsensitiveCompare(value, originalValue);
                        }
                        else {
                            return true;
                        }
                    }),
                });
            }
            else {
                field.childFields.forEach(function (child) {
                    var _a;
                    fieldShape[child.id] = Yup.object().shape({
                        value: (_a = fieldShape[field.id]) === null || _a === void 0 ? void 0 : _a.test("".concat(child.id, "-regex-test"), "".concat(child.label, " is invalid"), function (value) {
                            if (isVisible(field, this.parent, fieldViews)) {
                                if (!!field.validationExpression) {
                                    return ((!field.isRequired && !value) ||
                                        new RegExp(field.validationExpression).test(value));
                                }
                                else {
                                    return true;
                                }
                            }
                            else {
                                return true;
                            }
                        }),
                        confirmValue: fieldShape[field.id]
                            .test("".concat(child.id, "-regex-test"), "".concat(child.label, " is invalid"), function (value) {
                            if (isVisible(field, this.parent, fieldViews)) {
                                if (!!field.validationExpression) {
                                    return ((!field.isRequired && !value) ||
                                        new RegExp(field.validationExpression).test(value));
                                }
                                else {
                                    return true;
                                }
                            }
                            else {
                                return true;
                            }
                        })
                            .test("".concat(child.id, "-confirm-value-test"), "Confirmation value must match", function (value) {
                            if (isVisible(field, this.parent, fieldViews)) {
                                var originalValue = this.parent.value;
                                return caseInsensitiveCompare(value, originalValue);
                            }
                            else {
                                return true;
                            }
                        }),
                    });
                });
            }
        }
        else if (field.childFields.length === 0) {
            if (Constants.FieldsWithOptions.includes(field.type)) {
                var val_2 = [];
                if (Array.isArray(field.value)) {
                    var values_2 = field.value;
                    field.options.forEach(function (opt, index) {
                        var found = values_2.find(function (v) { return v.id === opt.id; });
                        val_2[index] = found ? found : null;
                    });
                }
            }
            if (!!field.isRequired) {
                if (!!field.parentFieldId) {
                    if (field.type === FieldType[FieldType.Signature]) {
                        fieldShape[field.id] = Yup.object().shape({
                            roles: Yup.array().of(Yup.object().shape({
                                email: Yup.string()
                                    .email("Email is required")
                                    .required("Email is required")
                                    .nullable(),
                                name: Yup.string()
                                    .required("Name is required")
                                    .nullable(),
                            })),
                        }).test("".concat(field.id, "-test"), "".concat(field.label, " is required"), function (value) {
                            return testRequiredness(value, field, this.parent, fieldViews);
                        });
                    }
                    else {
                        fieldShape[field.id] = fieldShape[field.id].test("".concat(field.id, "-test"), "".concat(field.label, " is required"), function (value) {
                            return testRequiredness(value, field, this.parent, fieldViews);
                        });
                    }
                }
                else if (field.type === FieldType[FieldType.Accept]) {
                    fieldShape[field.id] = fieldShape[field.id].oneOf(["True"], "You must answer \"Yes\" to ".concat(field.label));
                }
                else if (field.type === FieldType[FieldType.Signature]) {
                    fieldShape[field.id] = Yup.object().shape({
                        roles: Yup.array().of(Yup.object().shape({
                            email: Yup.string()
                                .email("Email is required")
                                .required("Email is required")
                                .nullable(),
                            name: Yup.string()
                                .required("Name is required")
                                .nullable(),
                        })),
                    });
                }
                else {
                    fieldShape[field.id] = fieldShape[field.id].required("".concat(field.label, " is required"));
                }
            }
            else {
                if (field.type === FieldType[FieldType.Signature]) {
                    fieldShape[field.id] = Yup.object().shape({
                        roles: Yup.array().of(Yup.object().shape({
                            email: Yup.string()
                                .email("Email is not formatted correctly")
                                .nullable(),
                            name: Yup.string()
                                .nullable(),
                        })),
                    });
                }
            }
            if (!!field.validationExpression) {
                //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                fieldShape[field.id] = fieldShape[field.id].test("".concat(field.id, "-regex-test"), "".concat(field.label, " is invalid"), function (value) {
                    if (isVisible(field, this.parent, fieldViews)) {
                        return (!field.isRequired && !value) || new RegExp(field.validationExpression).test(value);
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!!field.domainValidation && field.type === FieldType[FieldType.Email]) {
                if (((_d = (_c = field.domainValidation) === null || _c === void 0 ? void 0 : _c.disallowDomains) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                    fieldShape[field.id] = fieldShape[field.id].test("".concat(field.id, "-domain-test"), function (_a) {
                        var value = _a.value;
                        return "Emails from '".concat(value.split("@").pop(), "' are not allowed");
                    }, function (value) {
                        var _a, _b, _c;
                        if (((_a = field.domainValidation) === null || _a === void 0 ? void 0 : _a.disallowDomains) !== undefined &&
                            ((_b = field.domainValidation) === null || _b === void 0 ? void 0 : _b.disallowDomains.length) > 0) {
                            return !((_c = field.domainValidation) === null || _c === void 0 ? void 0 : _c.disallowDomains.some(function (d) {
                                return value === null || value === void 0 ? void 0 : value.toLowerCase().endsWith("@" + d);
                            }));
                        }
                        else {
                            return true;
                        }
                    });
                }
                else if (((_f = (_e = field.domainValidation) === null || _e === void 0 ? void 0 : _e.allowDomains) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                    fieldShape[field.id] = fieldShape[field.id].test("".concat(field.id, "-domain-test"), "Only emails from the following domains are allowed: ".concat(field.domainValidation.allowDomains.join(", ")), function (value) {
                        var _a, _b, _c;
                        if (((_a = field.domainValidation) === null || _a === void 0 ? void 0 : _a.allowDomains) !== undefined &&
                            ((_b = field.domainValidation) === null || _b === void 0 ? void 0 : _b.allowDomains.length) > 0) {
                            return (_c = field.domainValidation) === null || _c === void 0 ? void 0 : _c.allowDomains.some(function (d) {
                                return value === null || value === void 0 ? void 0 : value.toLowerCase().endsWith("@" + d);
                            });
                        }
                        else {
                            return true;
                        }
                    });
                }
            }
        }
        else {
            field.childFields.forEach(function (child) {
                fieldShape[child.id] = Yup.string().nullable();
                if (!!field.isRequired && !child.label.includes("Street 2")) {
                    if (!!field.parentFieldId) {
                        fieldShape[child.id] = fieldShape[child.id].test("".concat(child.id, "-test"), "".concat(child.label, " is required"), function (value) {
                            return testRequiredness(value, field, this.parent, fieldViews);
                        });
                    }
                    else {
                        fieldShape[child.id] = fieldShape[child.id].required("".concat(child.label, " is required"));
                    }
                    //}
                }
                if (!!field.validationExpression) {
                    //eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    fieldShape[child.id] = fieldShape[child.id].matches(new RegExp(field.validationExpression), "".concat(field.label, " (").concat(child.label, ") is invalid"));
                }
            });
        }
    });
    return fieldShape;
};
export var convertCurrencyStrToDecimal = function (currencyStr, intl, currency) {
    var _a, _b;
    var currencyAmount = 0;
    var v = intl.formatNumberToParts(1000.0, {
        style: "currency",
        currency: currency !== null && currency !== void 0 ? currency : "USD",
    });
    var symbol = ((_a = v.find(function (x) { return x.type === "currency"; })) === null || _a === void 0 ? void 0 : _a.value) || "$";
    var isCommaDecimal = ((_b = v.find(function (x) { return x.type === "decimal"; })) === null || _b === void 0 ? void 0 : _b.value) === ",";
    currencyAmount = currencyStr
        ? currencyStr === ""
            ? 0
            : isCommaDecimal
                ? parseFloat((currencyStr === null || currencyStr === void 0 ? void 0 : currencyStr.replace(/\s+/g, "").replace(",", ".").replace(symbol || "$", "")) || "0.00")
                : parseFloat((currencyStr === null || currencyStr === void 0 ? void 0 : currencyStr.replace(/\s+/g, "").replaceAll(",", "").replace(symbol || "$", "")) || "0.00")
        : 0;
    return currencyAmount;
};
export var Style = {
    base: ["color: #fff", "background-color: #4A525A", "padding: 2px 4px", "border-radius: 2px"],
    warning: ["color: #fff", "background-color: #FACF43"],
    error: ["color: #fff", "background-color:  #E71D36"],
    success: ["color: #fff", "background-color: #20BF55"],
    brand: ["color: #fff", "background-color: #004bed"],
};
export function log(text, extra) {
    if (extra === void 0) { extra = []; }
    var style = Style.base.join(";") + ";";
    style += extra.join(";"); // Add any additional styles
    console.log("%cBrushfire Widget: " + text, style);
}
export var guidsMatch = function (a, b) {
    if (a === void 0) { a = "a"; }
    if (b === void 0) { b = "b"; }
    return a.replaceAll("-", "").toLowerCase() === b.replaceAll("-", "").toLowerCase();
};
export var registrationPath = function (event, isAutoRegMode) {
    return (isAutoRegMode
        ? Constants.Routes.autoreg
        : event.verbiage === "Tickets"
            ? Constants.Routes.tickets
            : Constants.Routes.register)
        .replace(":clientKey", event.clientKey)
        .replace(":urlKey", event.urlKey)
        .replace(":eventNumber", event.eventNumber.toString());
};
export var getDefaultCountry = function (event) {
    var _a, _b, _c;
    var country = (_c = (_b = (((_a = event.country) === null || _a === void 0 ? void 0 : _a.length) === 2 ? event.country : null)) !== null && _b !== void 0 ? _b : event.clientCountry) !== null && _c !== void 0 ? _c : "US";
    return country;
};
